import { motion } from "framer-motion";

const STEPS = [
  { num: "01", title: "Source", copy: "We identify primary and resale opportunities." },
  { num: "02", title: "Advise", copy: "We help evaluate the unit, pricing and investment proposition." },
  { num: "03", title: "Fit Out", copy: "We coordinate professional interiors." },
  { num: "04", title: "Lease", copy: "We assist with leasing the completed asset." },
  { num: "05", title: "Manage", copy: "We remain your point of contact through the investment journey." },
];

export default function WhyHomewiz() {
  return (
    <section id="why-homewiz" data-testid="why-homewiz-section" className="py-28 sm:py-36 border-t border-white/[0.05]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#D4AF37]">Why Buy Through Us?</p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#F3F4F6] max-w-2xl">
            More than a <span className="gold-text italic">property transaction.</span>
          </h2>
        </motion.div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              data-testid={`homewiz-step-${s.num}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.08 * i, ease: [0.16, 1, 0.3, 1] }}
              className="group rounded-2xl border border-white/[0.07] bg-[#121418] p-6 border-l-2 border-l-[#D4AF37]/60 hover:border-[#D4AF37]/40 hover:bg-[#15171d] transition-all duration-500"
            >
              <div className="font-display text-3xl font-semibold text-white/15 group-hover:text-[#D4AF37]/50 transition-colors duration-500">
                {s.num}
              </div>
              <h3 className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-[#F3E5AB]">{s.title}</h3>
              <p className="mt-3 text-sm text-[#9CA3AF] leading-relaxed">{s.copy}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
